module.exports = __webpack_public_path__ + "img/magento-version-switching_small@2x.eccdde21.webp";